import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { Fab, Tooltip, styled, useMediaQuery } from '@mui/material';

import { Icon } from 'app/main/components';
import { navbarToggle, navbarToggleMobile } from 'app/store/fuse/navbarSlice';

type TooltipPosition = 'left' | 'right';

const Root = styled(Tooltip)<{ position: TooltipPosition }>(({ theme, position }) => ({
	'& > .button': {
		height: 40,
		position: 'absolute',
		zIndex: 99,
		top: 12,
		width: 24,
		borderRadius: 38,
		padding: 8,
		backgroundColor: theme.palette.background.paper,
		transition: theme.transitions.create(['background-color', 'border-radius', 'width', 'min-width', 'padding'], {
			easing: theme.transitions.easing.easeInOut,
			duration: theme.transitions.duration.shorter
		}),
		'&:hover': {
			width: 52,
			paddingLeft: 8,
			paddingRight: 8
		},
		'& > .button-icon': {
			fontSize: 18,
			transition: theme.transitions.create(['transform'], {
				easing: theme.transitions.easing.easeInOut,
				duration: theme.transitions.duration.short
			})
		},
		...(position === 'left' && {
			borderBottomLeftRadius: 0,
			borderTopLeftRadius: 0,
			paddingLeft: 4,
			left: 0
		}),
		...(position === 'right' && {
			borderBottomRightRadius: 0,
			borderTopRightRadius: 0,
			paddingRight: 4,
			right: 0,
			'& > .button-icon': {
				transform: 'rotate(-180deg)'
			}
		})
	}
}));

function NavbarToggleFab(props: { className?: string }) {
	const dispatch = useDispatch();
	const isMdDown = useMediaQuery(theme => theme.breakpoints.down('lg'));
	const config = useSelector(({ fuse }: any) => fuse.settings.current.layout.config);

	return (
		<Root
			title="Show Navigation"
			placement={config.navbar.position === 'left' ? 'right' : 'left'}
			position={config.navbar.position}
		>
			<Fab
				className={clsx('button', props.className)}
				onClick={() => dispatch(isMdDown ? navbarToggleMobile() : navbarToggle())}
				disableRipple
			>
				<Icon icon="menu" className="button-icon" />
			</Fab>
		</Root>
	);
}

export default NavbarToggleFab;
